import { render, staticRenderFns } from "./section-button.vue?vue&type=template&id=55b6dfdf"
import script from "./section-button.vue?vue&type=script&lang=ts"
export * from "./section-button.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports